import { Modal } from 'react-bootstrap';
import React, { memo } from 'react';
import { UserStatusCashbackClickInfoInner } from '../../UserStatus/components/UserStatusCashbackClickInfo';

function CashbackModal() {
    return <>
        <Modal.Header closeButton>
            {null}
        </Modal.Header>
        <div className={'pt-0 pb-4 px-4'}>
            <UserStatusCashbackClickInfoInner/>
        </div>
    </>;
}

export default memo(CashbackModal);
